import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SatRicLine extends Line {
    sat;
    coordinate_;
    lineLength = 2;
    constructor(sat, coordinate, color = LineColors.ORANGE) {
        super();
        this.sat = sat;
        this.coordinate_ = coordinate;
        this.color_ = color;
    }
    update() {
        const posData = ServiceLocator.getDotsManager().positionData;
        const position = {
            x: posData[this.sat.id * 3],
            y: posData[this.sat.id * 3 + 1],
            z: posData[this.sat.id * 3 + 2],
        };
        const satArr = [position.x, position.y, position.z];
        // Create In-Track Vector First
        const inTrack = { ...this.sat.velocity }; // Duplicate the velocity vector to avoid modifying the original
        // Normalize the velocity vector
        const inTrackMag = Math.sqrt(inTrack.x * inTrack.x + inTrack.y * inTrack.y + inTrack.z * inTrack.z);
        inTrack.x = inTrack.x / inTrackMag;
        inTrack.y = inTrack.y / inTrackMag;
        inTrack.z = inTrack.z / inTrackMag;
        // Now Create the Cross Track Vector (Cross Product of In-Track and Satellite Position)
        const r = position;
        const crossTrack = {
            x: r.y * inTrack.z - r.z * inTrack.y,
            y: r.z * inTrack.x - r.x * inTrack.z,
            z: r.x * inTrack.y - r.y * inTrack.x,
        };
        // Normalize the cross track vector
        const crossTrackMag = Math.sqrt(crossTrack.x * crossTrack.x + crossTrack.y * crossTrack.y + crossTrack.z * crossTrack.z);
        crossTrack.x = crossTrack.x / crossTrackMag;
        crossTrack.y = crossTrack.y / crossTrackMag;
        crossTrack.z = crossTrack.z / crossTrackMag;
        // Create the Radial Vector (Cross Product of In-Track and Cross-Track)
        const radial = {
            x: inTrack.y * crossTrack.z - inTrack.z * crossTrack.y,
            y: inTrack.z * crossTrack.x - inTrack.x * crossTrack.z,
            z: inTrack.x * crossTrack.y - inTrack.y * crossTrack.x,
        };
        // Normalize the radial vector
        const radialMag = Math.sqrt(radial.x * radial.x + radial.y * radial.y + radial.z * radial.z);
        radial.x = radial.x / radialMag;
        radial.y = radial.y / radialMag;
        radial.z = radial.z / radialMag;
        // Calculate a point this.lineLength in each direction from the satellite's position
        inTrack.x = position.x + inTrack.x * this.lineLength;
        inTrack.y = position.y + inTrack.y * this.lineLength;
        inTrack.z = position.z + inTrack.z * this.lineLength;
        crossTrack.x = position.x + crossTrack.x * this.lineLength;
        crossTrack.y = position.y + crossTrack.y * this.lineLength;
        crossTrack.z = position.z + crossTrack.z * this.lineLength;
        radial.x = position.x + radial.x * this.lineLength;
        radial.y = position.y + radial.y * this.lineLength;
        radial.z = position.z + radial.z * this.lineLength;
        let eciArr;
        switch (this.coordinate_) {
            case 'C':
                eciArr = [crossTrack.x, crossTrack.y, crossTrack.z];
                break;
            case 'I':
                eciArr = [inTrack.x, inTrack.y, inTrack.z];
                break;
            case 'R':
                eciArr = [radial.x, radial.y, radial.z];
                break;
            default:
                throw new Error('Invalid type');
        }
        this.updateVertBuf([eciArr, satArr]);
    }
}
